// extracted by mini-css-extract-plugin
module.exports = {"videoPlayerWrap":"vimeo-embed-warp_videoPlayerWrap__137_K","vimeoVideo":"vimeo-embed-warp_vimeoVideo__1A3Bx"};